// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

// Import your components
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import Services from './pages/Services';
import VendorPanel from './pages/VendorPanel';
import LabTestDashboard from './components/vendor-pandel/lab-test/LabTestDashboard';
import BloodBankDashboard from "./components/vendor-pandel/blood-bank/BloodBankDashboard"
import DiagnosticImagingCenter from './components/vendor-pandel/diagnostic-imaging/DiagnosticImagingCenter';
import Partner from './components/partner/Partner';
import PartnerFAQ from './components/partner/partner-faq/PartnerFaq';
import PartnerSignup from './components/partner/partner-signup/PartnerSignup';
import PartnerLogin from './components/partner/partner-login/PartnerLogin';
import TokenRedirector from './components/TokenRedirector';
// import NotFound from './NotFound';

function App() {
  return (
    <Router>
      {/* <TokenRedirector/> */}
      <div>
        <Navbar/>
        <Routes>
          {/* Define routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/vendor-panel" element={<VendorPanel />} />
          <Route path="/vendor-labtest-panel" element={<LabTestDashboard />} />
          <Route path="/vendor-blood-panel" element={<BloodBankDashboard />} />
          <Route path="/vendor-diagnostic-imaging" element={<DiagnosticImagingCenter />} />
          <Route path="/partner/register" element={<PartnerSignup />} />
          <Route path="/partner/login" element={<PartnerLogin />} />
          <Route path="/partner/faq" element={<PartnerFAQ />} />
          <Route path="/partner" element={<Partner />} />
          {/* Catch-all for unmatched routes */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
